import { Component, OnInit } from '@angular/core';
import { Tabs } from 'projects/access-control/src/app/Domain/Entities/tabs.interface';

@Component({
	selector: 'app-view-deploy-config',
	templateUrl: './view-deploy-config.component.html',
	styleUrls: ['./view-deploy-config.component.scss'],
})
export class ViewDeployConfigComponent implements OnInit {
	tabs: Tabs[] = [
		{
			value: '1',
			label: 'Mango Domain',
		},
		{
			value: '2',
			label: 'Custom Domain',
		},
	];
	constructor() {}

	ngOnInit(): void {}
}
